module.exports = __webpack_public_path__ + "img/accept.bbc75193.svg";